import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import { checkDNS } from '@/components/services/url-shortener-settings/domains/utils'

import render from './render'

export default {
  name: 'Item',

  mixins: [ checkDNS ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    }
  },

  render
}
